// import { logInDevEnv } from "@one.com/react-common/functions";
import IllustrationHosting from "../assets/websiteHosting.svg";
import IllustrationWordpress from "../assets/wordpress.svg";
import IllustrationShop from "../assets/shop.svg";
import IllustrationOwnTouch from "../assets/ownTouch.svg";
import IllustrationSecurity from "../assets/security.svg";
import IllustrationUberall from "../assets/uberall.svg";
import IllustrationMarketGoo from "../assets/marketGoo.svg";
import IllustrationEmailUnlimited from "../assets/emailUnlimited.svg";
import IllustrationDns from "../assets/dns.svg";
import IllustrationExchangeOnline from "../assets/exchange_online.svg";
import IllustrationExchangeBasicAndStandard from "../assets/exchange_basic_and_standard.svg";

// TODO: Move these product definitions similar to what's under /data/index.js
const getProductIcon = (productId) => {
  const productIcon = {
    DOMAIN: IllustrationHosting,
    PPS_EMAIL: IllustrationHosting,
    PPS_SMALL: IllustrationHosting,
    PPS_MEDIUM: IllustrationHosting,
    PPS_LARGE: IllustrationHosting,
    PPS_XXLARGE: IllustrationHosting,
    PPS_WEBSHOP: IllustrationHosting,
    WEBSITE_BUILDER_PREMIUM: IllustrationOwnTouch,
    WEBSITE_BUILDER_ECOMMERCE: IllustrationShop,
    SITELOCK_LITE: IllustrationSecurity,
    MARKETGOO_START: IllustrationMarketGoo,
    UBERALL: IllustrationUberall,
    WORDPRESS_MANAGED: IllustrationWordpress,
    DNS_ADMIN: IllustrationDns,
    MAIL_STORAGE_UNLIMITED: IllustrationEmailUnlimited,
    EXCHANGE_ONLINE: IllustrationExchangeOnline,
    EXCHANGE_M365_BUSINESS_BASIC: IllustrationExchangeBasicAndStandard,
    EXCHANGE_M365_BUSINESS_STANDARD: IllustrationExchangeBasicAndStandard,
    ONEVPS_SMALL: "vps",
    ONEVPS_MEDIUM: "vps",
    ONEVPS_LARGE: "vps",
    ONEVPS_XLARGE: "vps",
    ONEVPS_XXLARGE: "vps",
    MANAGED_ONEVPS_SMALL: "vps",
    MANAGED_ONEVPS_MEDIUM: "vps",
    MANAGED_ONEVPS_LARGE: "vps",
    MANAGED_ONEVPS_XLARGE: "vps",
    MANAGED_ONEVPS_XXLARGE: "vps",

    ONEVPS_PLESK_ADMIN_LICENSE: "plesk",
    ONEVPS_PLESK_PRO_LICENSE: "plesk",
    ONEVPS_PLESK_HOST_LICENSE: "plesk",
    ONEVPS_WINDOWS_LICENSE_SMALL: "os-windows",
    ONEVPS_WINDOWS_LICENSE_MEDIUM: "os-windows",
    ONEVPS_WINDOWS_LICENSE_LARGE: "os-windows",
    ONEVPS_WINDOWS_LICENSE_XXLARGE: "os-windows",
    ONEVPS_WINDOWS_LICENSE_XLARGE: "os-windows",
    ONEVPS_BASIC_BACKUP: "cloud-backup",
    WSB_MINI: IllustrationOwnTouch,
    WSB_BUSINESS: IllustrationOwnTouch,
    WSB_PRO: IllustrationOwnTouch,
    WSB_ECOMMERCE: IllustrationOwnTouch,
  }[productId];

  /* if (!productIcon) {
    logInDevEnv(
      [
        `WARNING: No product icon was configured for product ID "${productId}"!`,
        "(This warning is only shown in development, not in production)",
      ].join(" "),
      { logType: "warning" },
    );
  }
 */
  return productIcon;
};

export default getProductIcon;
